/**
 * @fileoverview gRPC-Web generated client stub for external
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.external = require('./antivirus_notification_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.AntivirusNotificationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.AntivirusNotificationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.ScanRequest,
 *   !proto.external.ScanResponse>}
 */
const methodDescriptor_AntivirusNotificationService_Scan = new grpc.web.MethodDescriptor(
  '/external.AntivirusNotificationService/Scan',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.external.ScanRequest,
  proto.external.ScanResponse,
  /**
   * @param {!proto.external.ScanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.ScanResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.ScanRequest,
 *   !proto.external.ScanResponse>}
 */
const methodInfo_AntivirusNotificationService_Scan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.external.ScanResponse,
  /**
   * @param {!proto.external.ScanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.ScanResponse.deserializeBinary
);


/**
 * @param {!proto.external.ScanRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.external.ScanResponse>}
 *     The XHR Node Readable Stream
 */
proto.external.AntivirusNotificationServiceClient.prototype.scan =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/external.AntivirusNotificationService/Scan',
      request,
      metadata || {},
      methodDescriptor_AntivirusNotificationService_Scan);
};


/**
 * @param {!proto.external.ScanRequest} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.external.ScanResponse>}
 *     The XHR Node Readable Stream
 */
proto.external.AntivirusNotificationServicePromiseClient.prototype.scan =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/external.AntivirusNotificationService/Scan',
      request,
      metadata || {},
      methodDescriptor_AntivirusNotificationService_Scan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.FileScannedRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AntivirusNotificationService_FileScanned = new grpc.web.MethodDescriptor(
  '/external.AntivirusNotificationService/FileScanned',
  grpc.web.MethodType.UNARY,
  proto.external.FileScannedRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.FileScannedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.FileScannedRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_AntivirusNotificationService_FileScanned = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.external.FileScannedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.external.FileScannedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.AntivirusNotificationServiceClient.prototype.fileScanned =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/external.AntivirusNotificationService/FileScanned',
      request,
      metadata || {},
      methodDescriptor_AntivirusNotificationService_FileScanned,
      callback);
};


/**
 * @param {!proto.external.FileScannedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.external.AntivirusNotificationServicePromiseClient.prototype.fileScanned =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/external.AntivirusNotificationService/FileScanned',
      request,
      metadata || {},
      methodDescriptor_AntivirusNotificationService_FileScanned);
};


module.exports = proto.external;

